// Import React and Hooks
import React, { useState, useEffect } from 'react'
// Import Redux and Hooks
import { Dispatch } from "redux"
import { useAppSelector, useAppDispatch } from './../../hooks/useRedux'
// Import Actions
import { showCutterImageAction, updateConfirmedImageAction } from '../../actions/createOfferingAction'
// Import React Cropper
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
// Import Components
import Button from './Button'
import FloatImg from './FloatImg'



// CutterImage Props
interface cutterImageProp {
  additionalClass?:string,
  dataCutterImage: {
    title:string,
    subtitle:string,
    text:string
  },
  initializerElement:any
}

const CutterImage = ( { additionalClass, dataCutterImage, initializerElement }:cutterImageProp ) => {



  // Use selector
  const isCutterImageVisible = useAppSelector( state => state.creatorOffering.isCutterImageVisible )
  const temporalImage = useAppSelector( state => state.creatorOffering.temporalImage )



  // Use dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use state
  const [image, setImage] = useState( '' )
  const [zoom, setZoom] = useState( 0.01 )
  const [completedCrop, setCompletedCrop] = useState( false )
  const [cropData, setCropData] = useState( '' )
  const [cropper, setCropper] = useState<any>()



  // Use effect
  useEffect( () => {
    setImage( temporalImage.url )
  }, [temporalImage] )

  useEffect( () => {
    if( completedCrop ) {
      dispatch( updateConfirmedImageAction({
        url: cropData,
        img: ''
      }) )
      setCompletedCrop( false )
    }
  }, [cropData] )



  // Function
  const getCropData = () => {
    if( typeof cropper !== 'undefined' ) {
      let menu = document.querySelector('main[role="main"]');
      {menu?.classList.contains('zIndex') ? menu?.classList.remove('zIndex') : menu?.classList.add('zIndex')}
      setCompletedCrop( true )
      setCropData( cropper.getCroppedCanvas({
        width: 410,
        height: 540
      }).toDataURL('image/jpeg') )
      dispatch( showCutterImageAction( false ) )
    }
  }

  function closeCutterImage() {
    dispatch( showCutterImageAction(false) )
    dispatch( updateConfirmedImageAction({
      url: '',
      img: ''
    }) )
    const initializerEl = document.getElementById(initializerElement) as HTMLInputElement
    if( initializerEl ) initializerEl.value = "";
    let menu = document.querySelector('main[role="main"]');
    menu?.classList.remove('zIndex');
    
  }

  function handleChangePhoto() {
    const initializerEl = document.getElementById(initializerElement)
    initializerEl && initializerEl.click()
  }

  function handleZoomIn() {
    const newZoom = zoom + 1
    console.log('zoom', zoom)
    setZoom( newZoom )
    console.log('newZoom', newZoom)
    console.log('yeap ZI')
  }

  function handleZoomOut() {
    const newZoom = zoom - 1
    console.log('zoom', zoom)
    zoom > 1 && setZoom( newZoom )
    console.log('newZoom', newZoom)
    console.log('yeap ZO')
  }



  // Destructuring
  const { title, subtitle, text } = dataCutterImage



  return (
    <section className={`cutterImage ${ !isCutterImageVisible ? 'hide' : '' } ${ additionalClass ? additionalClass : ''}`}>
      <div className="cutterImage__wrapper">
        <div className="cutterImage__container">
          <FloatImg
            additionalClass={`img1CutterImage`}
            alt="Arreglo floral"
            speed={ 0.013 }
            revert={ true }
            src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
          <FloatImg
            additionalClass={`img2CutterImage`}
            alt="Arreglo floral"
            speed={ 0.013 }
            revert={ true }
            src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
          <span
            onClick={ closeCutterImage }
            className="cutterImage__close" />
          <div className="cutterImage__bigBox">
            <article className="cutterImage__box">
              { title && (
                <h2 className="cutterImage__title hiddenMobile mb15 mbM10">
                  { title }
                </h2>
              ) }
              { subtitle && (
                <h3
                  className="cutterImage__subtitle mb25"
                  dangerouslySetInnerHTML={{ __html: subtitle }} />
              ) }
              { text && (
                <p className="cutterImage__text mb30">
                  { text }
                </p>
              ) }
              <div className="w100 taMC">
                { temporalImage.url && (
                  <Button
                    url="/"
                    additionalClass="m10 mM5 mbM15"
                    type="animated"
                    functionClick={ e => {
                      e.preventDefault()
                      getCropData()
                    } }
                    text="ACEPTAR" />
                ) }
                <Button
                  url="/"
                  additionalClass="btn--default m10 mM5"
                  functionClick={ (e) => {
                    e.preventDefault()
                    handleChangePhoto()
                  } }
                  text={ `${temporalImage.url ? 'CAMBIAR' : 'AGREGAR'} FOTO` } />
              </div>
            </article>
            <article className="cutterImage__box">
              { title && (
                <h2 className="cutterImage__title hiddenUpMobile mb15 mbM10">
                  { title }
                </h2>
              ) }
              <div className="cutterImage__crop mbM20">
                <Cropper
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                  className="Cropper-img"
                  zoomTo={ zoom }
                  aspectRatio={ 41 / 54 }
                  cropBoxResizable={ true }
                  dragMode={ 'move' }
                  src={ image }
                  viewMode={ 1 }
                  minCropBoxWidth={ 100 }
                  // minCanvasWidth={ 100 }
                  background={ false }
                  responsive={ true }
                  autoCropArea={ 1 }
                  checkOrientation={ false }
                  onInitialized={ (instance) => setCropper( instance ) }
                  guides={ false } />
                  {/* <div className="cutterImage__controls">
                    <button
                      className="cutterImage__button"
                      onClick={ handleZoomIn }>
                      <img src={`${window.assetsURl}/imgs/icons/zoom-in.svg`} alt="acercar" className="cutterImage__button__img" />
                    </button>
                    <button
                      className="cutterImage__button"
                      onClick={ handleZoomOut }>
                      <img src={`${window.assetsURl}/imgs/icons/zoom-out.svg`} alt="Alejar" className="cutterImage__button__img" />
                    </button>
                  </div> */}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}



export default CutterImage
